import * as R from 'ramda';
import {useRecords} from '../../models/records/records-provider';

import styles from './home.module.css';
import {Card} from 'primereact/card';
import {Button} from 'primereact/button';
import {useNavigate} from 'react-router-dom';
import {RoutesEnum} from '../../constants/routes';
import {formatAs800PhoneNumber} from '../../utils/phone';
import ZGalleria from '../../components/galleria/gelleria';
import {useAuth} from '../../providers/auth/auth-provider';

export const HomePage = () => {
  const navigate = useNavigate();
  const {
    mappedData,
  } = useRecords();
  const {
    openSignInModal,
    isAuthenticated,
    user,
  } = useAuth();
  const phoneNumber = mappedData['phone-8-800'];
  const phoneNumber2 = mappedData['phone-8-800_2'];
  const phoneToDisplay = formatAs800PhoneNumber(phoneNumber);
  const phoneToDisplay2 = formatAs800PhoneNumber(phoneNumber2);

  const cardProps = {
    pt: {
      root: {
        className: styles['home__card'],
      },
    }
  }

  const headerElement = (title: string, buttonConfig?: { cb: () => void, icon: string; label?: string }) => {
    const {
      cb,
      icon,
      label,
    } = buttonConfig ?? {};

    return (
      <div
        className={'flex justify-content-between'}
      >
        <div>{title}</div>
        <div>
          {
            !R.isNil(buttonConfig) && (
              <Button
                label={label}
                icon={icon}
                onClick={cb}
              />
            )
          }
        </div>
      </div>
    );
  }

  const cabinetHandler = () => {
    isAuthenticated ? navigate(`/${RoutesEnum.CABINET}`) : openSignInModal();
  }

  return (
    <div
      style={{
        backgroundImage: 'url(images/carousel04_min.jpg)',
        backgroundSize: 'cover',
      }}
    >
      <div
        className={styles['wrapper']}
      >
        <div style={{height: 100}}/>
        <div
          style={{
            padding: '16px 16px 0 16px'
          }}
        >
          <ZGalleria/>
        </div>
        <div
          className={styles['container']}
        >
          <div className={styles['col']}>
            <Card
              title={
                headerElement(
                  'Отключения',
                  {icon: 'pi pi-bolt', cb: () => navigate([RoutesEnum.CONSUMERS, RoutesEnum.SHUTDOWNS].join('/'))}
                )
              }
              {...cardProps}
            >
              <p className="m-0">
                Плановые и внеплановые отключения. Дополнительная информация по телефону горячей линии {phoneToDisplay}.
              </p>
            </Card>
          </div>
          <div className={styles['col']}>
            <Card
              title={
                headerElement(
                  'Личный кабинет' + (isAuthenticated ? ` (${user?.name})` : ''),
                  {icon: 'pi pi-user', cb: cabinetHandler}
                )
              }
              {...cardProps}
            >
              <p className="m-0">
                Личный кабинет потребителя/заявителя. Подать заявку.
              </p>
            </Card>
          </div>
          <div className={styles['col']}>
            <Card
              title={
                headerElement(
                  'Отчетность',
                  {icon: 'pi pi-file-check', cb: () => navigate([RoutesEnum.DOCUMENTS, RoutesEnum.ALL].join('/'))}
                )
              }
              {...cardProps}
            >
              <p className="m-0">
                Для контролирующих органов
              </p>
            </Card>
          </div>
          <div className={styles['col']}>
            <Card
              title={
                headerElement(
                  'Горячая линия',
                  {icon: 'pi pi-phone', cb: () => window.open(`tel:${phoneNumber}`)}
                )
              }
              subTitle={<div>{phoneToDisplay}<br/>{phoneToDisplay2}</div>}
              {...cardProps}
            >
              <p className="m-0">
                Центральная диспетчерская служба городского хозяйства тел.: 005
              </p>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
